<template>
  <div>
    <b-row>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-info bg-primary p-4 px-5 font-2xl mr-3 float-left"></i>
            <div class="h5 text-primary mb-0 pt-3" v-if="ready && data && !loading">{{ totalExpKg }} mil</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Total exportable</div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-info bg-secondary p-4 px-5 font-2xl mr-3 float-left"></i>
            <div class="h5 text-black mb-0 pt-3" v-if="ready && data && !loading">{{ totalKg }} mil</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Total volteado</div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-info bg-secondary p-4 px-5 font-2xl mr-3 float-left"></i>
            <div class="h5 text-dark mb-0 pt-3" v-if="ready && data && !loading">{{ totalPackedPercentage }} %</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Embalaje promedio</div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-info bg-secondary p-4 px-5 font-2xl mr-3 float-left"></i>
            <div class="h5 text-dark mb-0 pt-3" v-if="ready && data && !loading">{{ totalWastePercentage }} %</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Merma promedio</div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col> </b-row
    ><!--/.row-->
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      data: null, //sum_net_kilograms, exportable_kilograms
      ready: false,
      loading: true
    };
  },
  computed: {
    totalKg() {
      const val = this.data.sum_net_kilograms.reduce((a, b) => parseFloat(b) + a, 0);
      return new Intl.NumberFormat("es-CL").format((val / 1000).toFixed(2));
    },
    totalExpKg() {
      const val = this.data.exportable_kilograms.reduce((a, b) => parseFloat(b) + a, 0);
      return new Intl.NumberFormat("es-CL").format((val / 1000).toFixed(2));
    },
    totalPackedPercentage() {
      const packed = this.data.packed_kilograms.reduce((a, b) => parseFloat(b) + a, 0);
      const total = this.data.sum_net_kilograms.reduce((a, b) => parseFloat(b) + a, 0);
      return new Intl.NumberFormat("es-CL").format(((packed / total) * 100).toFixed(2));
    },
    totalWastePercentage() {
      const val = this.data.waste_kilograms.reduce((a, b) => parseFloat(b) + a, 0);
      const total = this.data.sum_net_kilograms.reduce((a, b) => parseFloat(b) + a, 0);
      return new Intl.NumberFormat("es-CL").format(((val / total) * 100).toFixed(2));
    }
  },
  props: ["client_customer", "from_date", "to_date", "product", "process_type"],
  async mounted() {
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/process/main_process?client_customer=${this.client_customer}&product=${this.product}&process_type=${this.process_type}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.data = response.data;
      this.ready = true;
      this.$emit("chart-ready");
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
  }
};
</script>

<style></style>
